<template>
<div class="chapter">
<div class="inner_page">
<h1 class="fm-title" id="fm-2"><a id="page_xiv"><strong>Abbreviations</strong></a></h1><a id="page_xiv">
<table>
<tbody>
<tr>
<td class="wid20">
<p class="t-left">11QPs<sup>a</sup></p></td>
<td class="wid80">
<p class="t-left"><em>Psalms Scroll</em> (Dead Sea Scrolls)</p></td>
</tr>
<tr>
<td class="wid20">
<p class="t-left"><em>b. Ber.</em></p></td>
<td class="wid80">
<p class="t-left"><em>Berakhot</em> (Babylonian Talmud)</p></td>
</tr>
<tr>
<td class="wid20">
<p class="t-left"><em>b. Sanh.</em></p></td>
<td class="wid80">
<p class="t-left"><em>Sanhedrin</em> (Babylonian Talmud)</p></td>
</tr>
<tr>
<td class="wid20">
<p class="t-left"><span class="smallcaps">CEB</span></p></td>
<td class="wid80">
<p class="t-left">Common English Bible</p></td>
</tr>
<tr>
<td class="wid20">
<p class="t-left"><span class="smallcaps">CEV</span></p></td>
<td class="wid80">
<p class="t-left">Contemporary English Version</p></td>
</tr>
<tr>
<td class="wid20">
<p class="t-left">IBT</p></td>
<td class="wid80">
<p class="t-left">Interpreting Biblical Texts</p></td>
</tr>
<tr>
<td class="wid20">
<p class="t-left">ICC</p></td>
<td class="wid80">
<p class="t-left">International Critical Commentary</p></td>
</tr>
<tr>
<td class="wid20">
<p class="t-left"><span class="smallcaps">JPS</span></p></td>
<td class="wid80">
<p class="t-left">Jewish Publication Society</p></td>
</tr>
<tr>
<td class="wid20">
<p class="t-left">JSOTSup</p></td>
<td class="wid80">
<p class="t-left">Journal for the Study of the Old Testament Supplement Series</p></td>
</tr>
<tr>
<td class="wid20">
<p class="t-left"><span class="smallcaps">KJV</span></p></td>
<td class="wid80">
<p class="t-left">King James Version</p></td>
</tr>
<tr>
<td class="wid20">
<p class="t-left"><span class="smallcaps">NIV</span></p></td>
<td class="wid80">
<p class="t-left">New International Version</p></td>
</tr>
<tr>
<td class="wid20">
<p class="t-left"><span class="smallcaps">NRSV</span></p></td>
<td class="wid80">
<p class="t-left">New Revised Standard Version</p></td>
</tr>
<tr>
<td class="wid20">
<p class="t-left"><span class="smallcaps">RSV</span></p></td>
<td class="wid80">
<p class="t-left">Revised Standard Version</p></td>
</tr>
<tr>
<td class="wid20">
<p class="t-left">SBL</p></td>
<td class="wid80">
<p class="t-left">Society of Biblical Literature</p></td>
</tr>
<tr>
<td class="wid20">
<p class="t-left">SBLDS</p></td>
<td class="wid80">
<p class="t-left">Society of Biblical Literature Dissertation Series</p></td>
</tr>
<tr>
<td class="wid20">
<p class="t-left"><em>TLOT</em></p></td>
<td class="wid80">
<p class="t-left"><em>Theological Lexicon of the Old Testament</em>. Ed. Ernst Jenni and Claus Westermann. Trans. Mark E. Biddle. 3 vols. Peabody, MA: Hendrickson, 1997.</p></td>
</tr>
</tbody>
</table>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 009_Abbreviations.vue?eb8eceb4